export const RQ_GET_ALL_DIGI_SIGNERS_BY_EVENT_ID = {
  url: 'v2/digi-document-all-signers/getSignerDetails/<%= eventId %>',
  method: 'GET',
  auth: true,
};
